import { Injectable } from '@angular/core';
import { BaseRestApiService } from '@shared/services/base-rest-api.service';
import { RestApiWrapperService } from '@shared/services/rest-api-wrapper.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProgramMessage } from './program-message.model';
import { ProgramConstant } from '@program/shared/program.constant';

@Injectable()
export class ProgramMessageService extends BaseRestApiService {
  constructor(restApiWrapperService: RestApiWrapperService) {
    super(restApiWrapperService);
  }

  public createMessage(programId: string, message: ProgramMessage): Observable<ProgramMessage> {
    return this.post<ProgramMessage>(ProgramConstant.message.createMessage(programId, message), JSON.stringify(message))
          .pipe(
            map((result: ProgramMessage) => new ProgramMessage(result))
          );
  }

  public getMessages(programId: string, participantId: string): Observable<ProgramMessage[]> {
    return this.get<ProgramMessage[]>(ProgramConstant.message.getMessage(programId, participantId), {params: {page: 0, size: 100, sort: 'sentDateTime,ASC'}})
            .pipe(
              map(results => results.map(result => new ProgramMessage(result)))
            );
  }

  // we may implement this in a future
  // public uploadAttachment(programId: string, participantId: string, fileName: string, json: {}): Observable<any> {
  //   const file = new File([JSON.stringify(json)], fileName, {type: 'text/json'});
  //   const formData = new FormData();
  //   formData.append('file', file);
  //   return this.put(`${this.url}/${programId}/messages/${participantId}/documents`, formData);
  // }
}
